module.exports = __webpack_public_path__ + "static/media/watch-mock.98a5ca3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/usecase-watch/assets/watch-mock.png
// module id = 62
// module chunks = 0